export default "__VITE_ASSET__CX$dgut8__"